import { sanitizeFilter } from './utils/buildFilterInput';

const mergeRanges = (
  a: RangeInput[],
  b: RangeInput[],
  c?: RangeInput[],
): RangeInput[] => {
  a = a || [];
  b = b || [];
  c = c || [];

  return [...a, ...b, ...c];
};

const getWildCards = (fi?: FilterInput) => {
  if (fi?.wildcardFilters) {
    return fi.wildcardFilters;
  }
  return [];
};
// Todo: merge filters
const mergeFilterInputs = (
  a: FilterInput,
  b: FilterInput,
  c?: FilterInput,
): FilterInput => {
  return sanitizeFilter({
    dataType: [
      ...(a.dataType || []),
      ...(b.dataType || []),
      ...(c?.dataType || []),
    ],
    keywords: [
      ...(a.keywords || []),
      ...(b.keywords || []),
      ...(c?.keywords || []),
    ],
    ranges: mergeRanges(a.ranges || [], b.ranges || [], c?.ranges || []),
    booleanFilters: [
      ...(a.booleanFilters || []),
      ...(b.booleanFilters || []),
      ...(c?.booleanFilters || []),
    ],
    wildcardFilters: [
      ...getWildCards(a),
      ...getWildCards(b),
      ...getWildCards(c),
    ],
    mustExistFilters: [
      ...(a.mustExistFilters || []),
      ...(b.mustExistFilters || []),
      ...(c?.mustExistFilters || []),
    ],
    mustNotExistFilters: [
      ...(a.mustNotExistFilters || []),
      ...(b.mustNotExistFilters || []),
      ...(c?.mustNotExistFilters || []),
    ],
    excludeTermedDrivers:
      a.excludeTermedDrivers ||
      b.excludeTermedDrivers ||
      c?.excludeTermedDrivers ||
      undefined,
  });
};

export default mergeFilterInputs;
